import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { logout, showSessionExpiredDialog } from '../store/slices/authSlice';
import { isTokenExpired } from '../utils/tokenUtils';

export const useTokenCheck = () => {
  const dispatch = useDispatch();
  const { token, isAuthenticated } = useSelector((state) => state.auth);
  const lastCheckedRef = useRef(0);
  
  useEffect(() => {
    // Skip if not authenticated or no token
    if (!isAuthenticated || !token) return;
    
    // Initial check with debounce to prevent multiple checks on mount
    const now = Date.now();
    if (now - lastCheckedRef.current > 2000) { // Only check if last check was > 2 seconds ago
      lastCheckedRef.current = now;
      
      if (isTokenExpired(token)) {
        dispatch(logout());
        dispatch(showSessionExpiredDialog());
        return;
      }
    }
    
    // Set up checks at a reasonable interval (every 60 seconds)
    // This is less frequent to reduce unnecessary checks
    const interval = setInterval(() => {
      if (isTokenExpired(token)) {
        dispatch(logout());
        dispatch(showSessionExpiredDialog());
      }
    }, 60000);
    
    return () => clearInterval(interval);
  }, [token, dispatch, isAuthenticated]);
};
